'use strict'

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import WmstLayer from '@/components/vue-map/layers/wmstLayer'

export default {
  computed: {
    ...mapState({
      layerLoading: state => state.layer.layerLoading,
      layerGroups: state => state.layer.layerGroups,
      sourceGroups: state => state.layer.sourceGroups,
      selectedLayers: state => state.layer.selectedLayers,
      layerGroupInfo: state => state.layer.layerGroupInfo,
      selectedModule: state => state.layer.selectedModule,
      showLayerList: state => state.layer.showLayerList,
      showSourceList: state => state.layer.showSourceList
    }),
    ...mapGetters([
      'availableSourceGroups',
      'availableModules',
      'currentLayers',
      'currentShownLayers',
      'showGroupList',
      'showModuleList',
      'filtredSourceGroups',
      'temporalLayers',
      'getShowSourceList', 
      'getShowLayerList'     
    ]),
    temporalLayers () {
      return this.currentLayers.filter((layer) => layer.constructor.serviceType === WmstLayer.serviceType && layer.layerGroup.webviewConfig.show)
    },
    hasTemporalLayers () {
      return this.temporalLayers.length > 0
    }
  },
  methods: {
    ...mapMutations([
      'toggleSelectedLayer',
      'addOrUpdateSourceGroup',
      'addOrUpdateLayerGroup',
      'setLayerGroupInfo',
      'removeLayerGroupInfo',
      'updateSelectedModule',
      'setShowSourceList',
      'setShowLayerList',
      'selectLayer'
    ]),
    ...mapActions([
      'addSourceGroup',
      'addSourceLayer',
      'removeLayerGroup',
      'removeLayer'
    ]),
  }
}
